module.exports = __webpack_public_path__ + "static/media/04.cbcc3201.jpg";